import { render, staticRenderFns } from "./MemberZx.vue?vue&type=template&id=b88963ba&scoped=true&"
import script from "./MemberZx.vue?vue&type=script&lang=js&"
export * from "./MemberZx.vue?vue&type=script&lang=js&"
import style0 from "./MemberZx.vue?vue&type=style&index=0&id=b88963ba&lang=scss&scoped=true&"
import style1 from "./MemberZx.vue?vue&type=style&index=1&id=b88963ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88963ba",
  null
  
)

export default component.exports